import { Component } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatBadgeModule } from '@angular/material/badge';
import { StepRecomPictureComponent } from '../step-recom-picture/step-recom-picture.component';
import { StepRecomDetailComponent } from '../step-recom-detail/step-recom-detail.component';

@Component({
  selector: 'dpi-step-recom-hub',
  imports: [MatTabsModule, MatBadgeModule, StepRecomPictureComponent, StepRecomDetailComponent],
  templateUrl: './step-recom-hub.component.html',
  styleUrl: './step-recom-hub.component.scss'
})
export class StepRecomHubComponent {
  pictureNum: number;

  constructor() {
    this.pictureNum = 0;
  }

  setPictureNum(count: number) {
    this.pictureNum = count;
  }
  
}
